<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">6.</span>
          <span>Dislocated Worker</span>
        </div>
        <p>Please enter your information regarding your eligibility in WIOA.</p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-type">
            <p class="heavy-text">Category 1</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Has your employment been Terminated/Laid-Off/Received Notice
                  of Termination or Lay-Off?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryOne.EmploymentTerminated.IsEmploymentTerminated'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryOne.employmentTerminated
                        .isEmploymentTerminated
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you Eligible for, or have exhausted, UI Benefits?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryOne.UIBenefits.IsEligibleForUIBenefit'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryOne.uiBenefits
                        .isEligibleForUIBenefit
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload a copy of UI award letter if applicable</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="uiBenefits"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon uiBenefits"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="uiBenefitsFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you ineligible for unemployment benefits due to
                  insufficient earnings of worked for an <br />
                  employer not covered under state Unemployment Insurance (UI)
                  law?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryOne.UnemploymentBenefits.IsIneligibleUnemploymentBenefits'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryOne.unemploymentBenefits
                        .isIneligibleUnemploymentBenefits
                    "
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                    <el-radio :label="2" size="large">Unsure</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you unlikely to return to your previous
                  industry/occupation?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryOne.PreviousOccupation.IsUnlikelyToReturnToPreviousOccupation'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryOne.previousOccupation
                        .isUnlikelyToReturnToPreviousOccupation
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you separated from military service, other than
                  dishonourable, whether voluntarily or involuntarily?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryOne.MilitaryService.IsSeparatedFromMilitaryService'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryOne.militaryService
                        .isSeparatedFromMilitaryService
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <p>
                  Please upload a copy of
                  <em style="cursor: default;">
                    DD-214, Certificate of Release or Discharge from Active Duty
                  </em>
                  or
                  <em style="cursor: default;"
                    >DD-215, Correction to DD-214, Certificate of Release or
                    Discharge from Active Duty
                  </em>
                  or other documentation that shows imminent separation.
                </p>
                <el-form-item>
                  <el-upload
                    drag
                    action="militaryService"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon militaryService"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="militaryServiceFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: “Recently separated veteran” means any veteran who applies
              for participation under WIOA within 48 months after discharge or
              release from active military, naval, air, or space service.
            </div>
          </div>
          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import * as utils from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      modelState: {},
      loading: false,
      uiBenefitsFileList: [],
      militaryServiceFileList: [],
      dislocatedWorker: {
        categoryOne: {
          employmentTerminated: { isEmploymentTerminated: null },
          uiBenefits: { isEligibleForUIBenefit: null, clientFiles: [] },
          unemploymentBenefits: { isIneligibleUnemploymentBenefits: null },
          previousOccupation: { isUnlikelyToReturnToPreviousOccupation: null },
          militaryService: {
            isSeparatedFromMilitaryService: null,
            clientFiles: []
          }
        }
      },
      newUiBenefitsUploadInd: false,
      newMilitaryServiceUploadInd: false,
      validFileExtensions: [
        ...utils.imageFileExtensions,
        ...utils.documentFileExtensions
      ],
      document: {
        type: Object,
        default() {
          return {
            id: "",
            name: "",
            filename: "",
            documentObjectId: "",
            documentObjectUrl: "",
            isImage: false
          };
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
      .then(() => {
        if(this.newUiBenefitsUploadInd || this.newMilitaryServiceUploadInd)
        {
            if(this.dislocatedWorker.categoryOne.uiBenefits.clientFiles[0].fileId && this.newUiBenefitsUploadInd){
              this.navigateAwayRemoveAttachment(this.dislocatedWorker.categoryOne.uiBenefits.clientFiles[0].fileId);
              this.dislocatedWorker.categoryOne.uiBenefits.clientFiles = [];
            }
            
            if(this.dislocatedWorker.categoryOne.militaryService.clientFiles[0].fileId && this.newMilitaryServiceUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.dislocatedWorker.categoryOne.militaryService.clientFiles[0].fileId);
              this.dislocatedWorker.categoryOne.militaryService.clientFiles = [];
            }

            this.$message.success("Your checklist are saved as draft!");
            localStorage.removeItem("editChecklist");
            next();
        }
        else
        {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        }
      })
      .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0,0);
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          // this.dislocatedWorker = res.checklist.dislocatedWorker;
          if (res.checklist.dislocatedWorker)
          {
            if (res.checklist.dislocatedWorker.categoryOne) 
            {
              this.dislocatedWorker.categoryOne = res.checklist.dislocatedWorker.categoryOne;
              res.checklist.dislocatedWorker.categoryOne.uiBenefits.clientFiles.forEach(element => {
                this.uiBenefitsFileList.push({'name': element.fileName, 'url': element.fileId});
              });

              res.checklist.dislocatedWorker.categoryOne.militaryService.clientFiles.forEach(element => {
                this.militaryServiceFileList.push({'name': element.fileName, 'url': element.fileId});
              });
            }
          }
            // this.dislocatedWorker = res.checklist.dislocatedWorker;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    navigateAwayRemoveAttachment(objectId){
      const param = {
          objectId: objectId,
          bucketType: BucketType.WioaChecklist,
        };
        this.$store
          .dispatch("common/removefile", param)
          .then(() => {
            return true;
          })
          .catch((res) => {
            this.$message.success("Something went wrong. Please contact talentsensus admin.");
            return false
          });
    },
    removeUpload(file, fileList){
      let uploadElement = event.target.parentElement.parentElement.parentElement;
      this.loading = true;
      file.url = (file.url == null && file.name != null) ? file.raw.url : file.url;
      const param = {
        objectId: file.url,
        bucketType: BucketType.WioaChecklist
      };
      this.$store.dispatch("common/removefile", param).then(() => {
        if(uploadElement.classList.contains('uiBenefits'))
        {
          this.dislocatedWorker.categoryOne.uiBenefits.clientFiles = [];
        }
        else if(uploadElement.classList.contains('militaryService'))
        {
          this.dislocatedWorker.categoryOne.militaryService.clientFiles = [];
        }
        this.$message.success("Document removed!");
      })
      .catch((res) => {
      })
      .finally(() => {
        this.loading = false;
      });
    },
    handleExceed(){
      this.showPopUpMessage(
          "Upload",
          `You can only upload 1 file.`
        );
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklistFive",
        params: { checklistId: this.getChecklistId() }
      });
    },
    updateCheckList() {
      this.loading = true;
      let checklist = {
        type: 3.1,
        checklist: {
          id:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId,
          dislocatedWorker: this.dislocatedWorker
        }
      };
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "WioaChecklistSeven",
              params: { checklistId: this.getChecklistId() }
            });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocument(param) {
      this.loading = true;

      this.$store
        .dispatch(
          "wioa/generateUploadDocumentMetadata",
          this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.storeDocument(param, metadata);
        })
        .catch(err => param.onError(err, param.file, param.fileList));
    },
    storeDocument(param, metadata) {
      const { file } = param;
      const fileExtension = utils.getFileExtension(file.name);

      this.$store
        .dispatch("common/uploadDocumentWithReturnUrl", {
          file,
          objectId:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
          bucketType: BucketType.WioaChecklist,
          fileExtension
        })
        .then(url => {
          this.document.id = metadata.documentId;
          this.document.filename = file.name;
          this.document.isImage = utils.isImage(file.name);
          this.document.documentObjectId = metadata.documentObjectId;
          this.document.documentObjectUrl = url;

          if (param.action == "uiBenefits") {
            this.dislocatedWorker.categoryOne.uiBenefits.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newUiBenefitsUploadInd = true;
          } else {
            this.dislocatedWorker.categoryOne.militaryService.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newMilitaryServiceUploadInd = true;
          }
          param.file.url = this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId;
        })
        .catch(err => {
          param.onError(err, param.file, param.fileList);
        })
        .finally(() => (this.loading = false));
    },
    beforeUpload(file) {
      const fileExtension = utils.getFileExtension(file.name);

      if (this.validFileExtensions.indexOf(fileExtension) === -1) {
        this.showPopUpMessage(
          "Upload",
          `Invalid file type. Only ${this.validFileExtensions.join(
            ", "
          )} are allowed.`
        );
        this.loading = false;
        return false;
      }

      const fileLimitExceeded = file.size / 1024 / 1024 > 3;
      if (fileLimitExceeded) {
        this.showPopUpMessage("Upload", "File size cannot exceed 3MB");
        this.loading = false;
        return false;
      }

      return true;
    },
    onError() {
      this.loading = false;
      this.presignedUpdateUrl = "";

      this.document.id = "";
      this.document.filename = "";
      this.document.documentObjectId = "";
      this.document.documentObjectUrl = "";
      this.document.isImage = false;

      this.showPopUpMessage("Upload", "Unable to upload file.");
    },
    showPopUpMessage(title, msg, type = "error") {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => false);
    },
    isImage(filename) {
      return utils.isImage(filename);
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>
